// Date inputs store 'YYYY-MM-DD', which new Date() reads as UTC midnight — the
// evening before in US time zones, so local getters/display land a day early.
// Date-only strings are parsed as local midnight; anything else as usual.
export function parseDay(value) {
  if (value instanceof Date) return new Date(value);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value ?? '').trim());
  return m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(value);
}

export function formatDateToMMDDYYYY(date) {
  if (!date) return '';
  let parsedDate = typeof date === 'string' ? new Date(date + 'T00:00:00') : new Date(date);
  if (isNaN(parsedDate.getTime())) return '';
  return parsedDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

export function formatDateToMMDD(date) {
  if (!date) return '';
  let parsedDate = typeof date === 'string' ? new Date(date + 'T00:00:00') : new Date(date);
  if (isNaN(parsedDate.getTime())) return '';
  return parsedDate.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
  });
}

export function formatDateToYYYYMMDD(date) {
  if (!date) return '';
  let parsedDate = typeof date === 'string' ? new Date(date + 'T00:00:00') : new Date(date);
  if (isNaN(parsedDate.getTime())) return '';
  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const day = String(parsedDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getEndOfCurrentWeek() {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 for Sunday, 6 for Saturday
  const diff = dayOfWeek === 0 ? 0 : 7 - dayOfWeek; // Days until Sunday
  today.setDate(today.getDate() + diff); // Adjust to the next Sunday
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // Month is zero-based
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
